import { writable } from '../external_node_modules/svelte/store/index.mjs.js';
import { EVENTS } from '../constants/events.js';
import events from '../core/event/index.js';

const activePaymentMethod = undefined;
const { subscribe, update } = writable(activePaymentMethod);
function updateActivePaymentMethod(methods) {
    const bindingsMethods = methods.filter((method) => { var _a; return !!((_a = method.bindingsInfo) === null || _a === void 0 ? void 0 : _a.length); });
    return update((state) => {
        if (bindingsMethods[0]) {
            state = bindingsMethods[0];
        }
        else {
            state = null;
        }
        events.emit(EVENTS.ACTIVE_PAYMENT_METHOD, { paymentMethod: state });
        return state;
    });
}
var activePaymentMethod$1 = {
    subscribe,
};

export { activePaymentMethod$1 as default, updateActivePaymentMethod };
//# sourceMappingURL=activePaymentMethod.js.map
